module.exports = __webpack_public_path__ + "img/small.93b9405a.jpg";